export function partitionMedications(medications) {
  const current = [];
  const past = [];

  for (const medication of medications || []) {
    if ((medication?.status || 'current') === 'past') {
      past.push(medication);
    } else {
      current.push(medication);
    }
  }

  current.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
  past.sort((a, b) => new Date(b.endDate || b.startDate) - new Date(a.endDate || a.startDate));

  return { current, past };
}

export function buildDailyLog(medications, day = new Date()) {
  const start = new Date(day);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);

  const entries = [];
  for (const med of medications || []) {
    for (const [index, log] of (med.logs || []).entries()) {
      const ts = new Date(log.timestamp);
      if (ts >= start && ts < end) {
        entries.push({
          medicationId: med._id,
          medicationName: med.productName || med.medicationName,
          dosage: med.dosage,
          din: med.din || '',
          logId: log.logId || log._id || `${String(med._id)}-${String(log.timestamp)}-${String(log.status)}-${index}`,
          status: log.status,
          timestamp: log.timestamp,
        });
      }
    }
  }

  entries.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  return entries;
}

export function summarizeMedicationsForChatbot(medications) {
  const { current, past } = partitionMedications(medications || []);

  const formatMedicationLabel = (medication) => {
    const name = medication?.productName || medication?.medicationName || 'Medication';
    return medication?.din ? `${name} (DIN ${medication.din})` : name;
  };

  const currentLines = current.slice(0, 8).map((m) =>
    `- ${formatMedicationLabel(m)} (${m.dosage}, ${m.frequency})${m.instructions ? ': ' + m.instructions : ''}`
  );
  const pastLines = past.slice(0, 5).map((m) =>
    `- ${formatMedicationLabel(m)} (${m.dosage}) ended ${m.endDate ? new Date(m.endDate).toLocaleDateString('en-CA') : 'unknown date'}`
  );

  const parts = [];
  if (currentLines.length) {
    parts.push(`Current medications:\n${currentLines.join('\n')}`);
  }
  if (pastLines.length) {
    parts.push(`Past medications:\n${pastLines.join('\n')}`);
  }

  return parts.join('\n\n');
}

export const LOG_STATUS_META = {
  taken: { label: 'Taken', bg: '#E3F0EE', color: '#338477' },
  skipped: { label: 'Skipped', bg: '#FAEEDA', color: '#B26A00' },
  missed: { label: 'Missed', bg: '#FCEBEB', color: '#C53030' },
};
